<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <team-users :teamId="props.teamId" :readOnly="team.status === 'closed'" />
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import TeamUsers from '~/components/settings/teams/membership/TeamUsers.vue';
import { useTeamDetails } from '../composables/useTeamDetails';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { team } = useTeamDetails();
</script>
